import powerpoint from '@/assets/images/ds-logos/microsoft-powerpoint.svg'
import excel from '@/assets/images/ds-logos/microsoft-excel.svg'
import word from '@/assets/images/ds-logos/microsoft-word.svg'
import pdf from '@/assets/images/ds-logos/pdf.svg'
import googleSlides from '@/assets/images/ds-logos/google-slides.svg'
import googleDrive from '@/assets/images/ds-logos/google-drive.svg'
import oneDrive from '@/assets/images/ds-logos/microsoft-onedrive.svg'

export const DS_LOGOS = {
  powerpoint,
  excel,
  word,
  pdf,
  googleSlides,
  googleDrive,
  oneDrive,
}
